import React from "react";
import Contact from "../components/Contact";
import ServiceHeader from "../components/ServiceHeader";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import contact_img from "../static/img/service_header.jpg";
function ContactUsPage() {
  return (
    <>
      <Nav />
      <ServiceHeader
        image={contact_img}
        title={"Get In Touch."}
        description={"We welcome inquiries, professional correspondence, and opportunities for collaboration. Please use the information below to connect with the appropriate team at SPP Insolvency Professionals LLP. Our team is committed to providing a timely and confidential response."}
      />
      <Contact />
      <Footer />
    </>
  );
}
export default ContactUsPage;
